// True when running inside the Capacitor shell (the App Store / native build).
// Used to hide web-only UI (install prompts) and all purchase flows — the
// native app sells nothing; plans are managed on ellai.app (web), so Apple's
// in-app-purchase rules never apply.
export function isNativeApp() {
  try {
    return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
  } catch {
    return false;
  }
}
